import { render, staticRenderFns } from "./CounterpartyHistory.vue?vue&type=template&id=00395d90"
import script from "./CounterpartyHistory.vue?vue&type=script&lang=js"
export * from "./CounterpartyHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports